import React from "react";
import { Star, Quote, MessageCircle } from "lucide-react";
import { testimonials, OFFER_ANCHOR, CTA_TEXT } from "../../data/mock";
import { Button } from "../ui/button";

const whatsappImages = [
  "/site-images/whatsapp-01.png",
];

const Testimonials = () => {
  return (
    <section className="section-pad bg-gradient-to-b from-pink-50/70 to-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-serif-display font-black text-2xl md:text-5xl text-pink-700 leading-tight">
            Quem comprou, adorou
          </h2>
          <div className="mt-3 flex items-center justify-center gap-1 text-amber-400 flex-wrap">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" />
            ))}
            <span className="ml-2 text-pink-900 font-semibold text-sm md:text-base">4.9/5 • +12.000 alunas</span>
          </div>
        </div>

        {/* WhatsApp print testimonials */}
        <div className="mt-6 md:mt-10">
          <div className="flex items-center justify-center gap-2 mb-4 md:mb-6">
            <MessageCircle className="w-4 h-4 md:w-5 md:h-5 text-green-600" />
            <span className="text-[11px] md:text-sm font-bold text-green-700 uppercase tracking-widest">
              Prints reais de clientes
            </span>
          </div>
          <div className="grid sm:grid-cols-1 gap-4 md:gap-6 max-w-md md:max-w-lg mx-auto">
            {whatsappImages.map((src, i) => (
              <figure
                key={i}
                className="card-hover relative overflow-hidden rounded-2xl bg-white border-2 border-green-200 shadow-md"
              >
                <img
                  src={src}
                  alt={`Depoimento WhatsApp ${i + 1}`}
                  className="w-full h-auto block"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-green-500 text-white text-[10px] md:text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-md flex items-center gap-1">
                  <MessageCircle className="w-3 h-3" /> Real
                </div>
              </figure>
            ))}
          </div>
        </div>

        {/* Text testimonials */}
        <div className="mt-8 md:mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className="card-hover relative bg-white rounded-2xl p-4 md:p-6 border border-pink-100 shadow-sm"
            >
              <Quote className="absolute top-3 right-3 w-6 h-6 md:w-8 md:h-8 text-pink-200" />
              <div className="flex items-center gap-1 text-amber-400 mb-2 md:mb-3">
                {[...Array(t.stars)].map((_, j) => (
                  <Star key={j} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-current" />
                ))}
              </div>
              <p className="text-pink-900/85 text-[13px] md:text-[15px] leading-relaxed">“{t.text}”</p>
              <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-pink-100">
                <div className="font-bold text-pink-800 text-sm md:text-base">{t.name}</div>
                <div className="text-[11px] md:text-xs text-pink-900/60">{t.role}</div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 md:mt-10 text-center">
          <a href={OFFER_ANCHOR}>
            <Button size="lg" className="w-full sm:w-auto bg-gradient-to-b from-pink-500 to-rose-600 hover:from-pink-600 hover:to-rose-700 text-white font-bold px-6 md:px-8 py-5 rounded-full shadow-lg text-sm md:text-base">
              👉 {CTA_TEXT}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
